export default __webpack_public_path__ + "static/media/P1010546.82b30d0e.jpg";